/*eslint-disable */
import { bus } from '@/main';
export default {
  name: 'remove-candidate-info-popup',
  components: {},
  props: ['removeCandidateID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getCandidateListAgainMethod(){
      this.$store.dispatch('getInViewerCandidateListAction')
    },
    confirmEvtDeletePopupMethod(){
        this.isSubmitted = true
        this.$store.dispatch('removeInVCandidateInfoAction', {id:this.removeCandidateID}).then((res) => {
          this.getCandidateListAgainMethod();
          this.closeEvtDeletePopupMethod();
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
        })
    },
    closeEvtDeletePopupMethod(){
      bus.$emit('removeCandidatePopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}


